import * as React from "react"
import { FaUser } from "react-icons/fa"
import { gql } from "@apollo/client"
import { Avatar, Box, Flex, Link, SimpleGrid, Stack, Text, Tooltip } from "@chakra-ui/react"
import NextLink from "next/link"

import { CollaboratorItemFragment } from "lib/graphql"

const _ = gql`
  fragment CollaboratorItem on User {
    id
    firstName
    avatarUrl
  }
`

interface Props {
  collaborators: CollaboratorItemFragment[]
}

export function ProjectCollaborators({ collaborators }: Props) {
  return (
    <Stack spacing={4} overflow="hidden" mt={6} mb={12}>
      <Flex fontWeight="bold" color="gray.200" justifyContent="space-between">
        <Text fontSize="lg">Collaborators</Text>
      </Flex>
      <SimpleGrid columns={{ base: 3, md: 5 }} spacing={1}>
        {collaborators.map((collaborator) => {
          return (
            <Tooltip
              key={collaborator.id}
              label={collaborator.firstName}
              bg="yellow.500"
              color="black"
              fontWeight="bold"
            >
              <Box mb={2} mr={2}>
                <NextLink href={`/users/${collaborator.id}`} passHref>
                  <Link _hover={{ textDecor: "none" }}>
                    <Avatar
                      src={collaborator.avatarUrl || undefined}
                      name={collaborator.firstName || "avatar"}
                      w="65px"
                      h="65px"
                      bg="gray.600"
                      icon={<FaUser color="gray.900" size={18} />}
                      aria-label={`${collaborator.firstName || "Medewerker"} avatar`}
                    />
                  </Link>
                </NextLink>
              </Box>
            </Tooltip>
          )
        })}
      </SimpleGrid>
    </Stack>
  )
}
